import React from 'react';
import PropTypes from 'prop-types';

import { View } from 'react-native-web';

import SaveMoneySlide from './SaveMoney';
import ClientsLoveItSlide from './ClientsLoveIt';
import GetPaidNowSlide from './GetPaidNow';

import BodyText from '../../../ui/BodyText';
import { HeaderText } from '../../../ui/HeaderText';
import InfoSwiper from '../../../ui/InfoSwiper';
import analytics from '../../../../modules/analytics';

/**
 * The payments value swiper
 */
export default function PaymentsValueSwiper(props) {
  const {
    /** INTERNAL USE -- DO NOT SET (set by modalManager)
        The DOM node the modal was rendered into. */
    renderContainer,
    showPaymentsButton,
  } = props;

  return (
    <InfoSwiper
      renderContainer={renderContainer}
      className="payments-value-swiper"
      onSlideViewed={pageNo => analytics.track('pro_payments_value_swiper_viewed', { page_number: pageNo + 1 })}
      onDismissed={pageNo => analytics.track('pro_payments_value_swiper_dismissed', { page_number: pageNo + 1 })}
    >
      <View className="slide-1 slide-content">
        <HeaderText level="1">Save money,{'\n'}get paid quickly</HeaderText>
        <BodyText>
          Charge clients through StyleSeat and end the day with more money in your pocket.
        </BodyText>
      </View>
      <View className="slide-content">
        <SaveMoneySlide
          showPaymentsButton={showPaymentsButton}
        />
      </View>
      <View className="slide-content">
        <GetPaidNowSlide
          showPaymentsButton={showPaymentsButton}
        />
      </View>
      <View className="slide-content">
        <ClientsLoveItSlide
          showPaymentsButton={showPaymentsButton}
        />
      </View>
    </InfoSwiper>
  );
}

PaymentsValueSwiper.propTypes = {
  renderContainer: PropTypes.object.isRequired,
  /** boolean to show the payments setup button */
  showPaymentsButton: PropTypes.bool,
};

PaymentsValueSwiper.defaultProps = {
  showPaymentsButton: false,
};
